import type { TFunction } from "i18next";

export type ApplicationFilter =
  | "Accepted"
  | "All"
  | "Offered"
  | "Rejected"
  | "Withdrawn";

export type ApplicationListView = "All" | "Pending";

export interface ApplicationFilterOption {
  readonly label: string;
  readonly value: ApplicationFilter;
}

export function getApplicationFilterOptions(
  t: TFunction,
): ApplicationFilterOption[] {
  return [
    { value: "All", label: t("ApplicationsCompany.AllStatuses") },
    { value: "Accepted", label: t("ApplicationsCompany.Hired") },
    { value: "Rejected", label: t("ApplicationsCompany.NotSelected") },
    { value: "Offered", label: t("GigsCompany.Offered") },
  ];
}

export function isApplicationFilter(value: string): value is ApplicationFilter {
  switch (value) {
    case "Accepted":
    case "All":
    case "Offered":
    case "Rejected":
    case "Withdrawn":
      return true;
    default:
      return false;
  }
}
